export default "__VITE_ASSET__B1WKh3Tt__"